import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Typography, Box } from "@mui/material";

const colors = [
  "#6B2CFF", "#A7C7FF", "#00F9D9", "#40F700",
  "#FFE600", "#FF9F00", "#FF2A2A", "#66B3FF",
  "#F27FFF", "#4CA9FF", "#2A9B00", "#D65CDB",
  "#FFD700", "#FF4D00", "#FF6AF5", "#FF7ED0"
];

const letters = [
  { char: "a", x: 150, y: 153, size: 165 },
  { char: "ಕ", x: 150, y: 163, size: 120 },
  { char: "अ", x: 143, y: 164, size: 115 },
  { char: "ক", x: 150, y: 164, size: 105 },
  { char: "గ", x: 150, y: 164, size: 112 },
  { char: "த", x: 150, y: 140, size: 115 },
  { char: "മ", x: 150, y: 164, size: 117 },
  { char: "ଓ", x: 150, y: 164, size: 116 },
  { char: "પ", x: 150, y: 164, size: 119 },
  { char: "ਲ", x: 150, y: 164, size: 113 },
  { char: "அ", x: 150, y: 140, size: 105 }
];

const AnimatedLogo = () => {
  const [letterIndex, setLetterIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setLetterIndex((prevIndex) => (prevIndex + 1) % letters.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center"
      height="40vh" 
      bgcolor="black" 
      color="white"
      sx={{ padding: { xs: 2, sm: 4 } }}
    >
      {/* Logo Row */}
      <Box 
        display="flex" 
        flexDirection="row" 
        justifyContent="center" 
        alignItems="center"
      >
        <Typography 
          variant="h1" 
          component="h1"
          sx={{ 
            fontFamily: 'Source Serif Variable', 
            fontSize: { xs: '25pt', sm: '50pt', md: '70pt' },
            textAlign: "center", 
            fontWeight: 300,
            letterSpacing: 4,
          }}
        >
          Anthr
        </Typography>

        <Box 
          position="relative" 
          width="15vw" 
          height="15vw" 
          sx={{ maxWidth: 130, maxHeight: 130 }}
        >
          <svg width="100%" height="100%" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
            <motion.g animate={{ rotate: [0, 360] }} transition={{ repeat: Infinity, duration: 8, ease: "linear" }}>
              {colors.map((color, index) => {
                const angle = (index * 22.5) * (Math.PI / 180);
                const x1 = 150 + Math.cos(angle) * 80;
                const y1 = 150 + Math.sin(angle) * 80;
                const x2 = 150 + Math.cos(angle) * 140;
                const y2 = 150 + Math.sin(angle) * 140;
                return (
                  <line
                    key={index}
                    x1={x1}
                    y1={y1}
                    x2={x2}
                    y2={y2}
                    stroke={color}
                    strokeWidth="5"
                  />
                );
              })}
            </motion.g>

            {letters.map((letter, index) => (
              <motion.text 
                key={index} 
                x={letter.x} 
                y={letter.y} 
                textAnchor="middle" 
                fontSize={letter.size} 
                fontFamily="Source Serif Variable" 
                fontWeight="300"
                fill="white"
                dominantBaseline="middle"
                initial={{ opacity: 0, fontSize: 0 }} 
                animate={{ opacity: letterIndex === index ? 1 : 0, fontSize: letter.size }} 
                transition={{ duration: 1, ease: "easeInOut" }}
              >
                {letter.char}
              </motion.text>
            ))}
          </svg>
        </Box>

        <Typography 
          variant="h1" 
          sx={{ 
            fontFamily: 'Source Serif Variable', 
            fontSize: { xs: '25pt', sm: '50pt', md: '70pt' },
            textAlign: "center", 
            fontWeight: 300,
            letterSpacing: 4,
          }}
        >
          sync
        </Typography>
      </Box>

      {/* Tagline Below the Logo */}
  <Typography 
  variant="h6"
  sx={{ 
    fontFamily: 'Source Serif Variable', 
    fontWeight: 300, 
    letterSpacing: 4,
    color: 'white', 
    textAlign: 'center',
    mt: 2
  }}
>
  Bringing minds together in real time.
</Typography>


    </Box>
  );
};

export default AnimatedLogo;
